<template>
  <div
    class="px-10 min-h-[calc(100vh_-_90px)] sm:min-h-[calc(100vh_-_90px)] overflow-x-hidden bg-white"
  >
    <div
      class="container max-w-[1200px] mx-auto flex flex-wrap items-center sm:min-h-[calc(100vh_-_90px)]"
    >
      <div class="py-10 w-full text-center mb-10 mt-20">
        <h1 class="text-3xl sm:text-5xl font-bold mt-2 mb-5">
          How CSV RAG Works
        </h1>
        <p class="text-xl text-alto-500">
          Transform your static CSV data into an interactive RAG application for yourself or your customers.
        </p>
        <div class="flex flex-wrap my-10 items-stretch">
          <div class="w-full md:w-1/2 lg:w-1/4 px-5 my-5 relative">
            <div class="rounded-3xl shadow-lg px-8 py-8 text-center">
              <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                1
              </div>
              <h3 class="text-2xl font-bold">Upload your CSV Files</h3>
              <p class="text-lg text-alto-500 mt-3">
                Easily upload your CSV files to start leveraging powerful search and chat functionalities.
              </p>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 px-5 my-5 relative">
            <div class="rounded-3xl shadow-lg px-8 py-8 text-center">
              <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                2
              </div>
              <h3 class="text-2xl font-bold">Select Vector Columns</h3>
              <p class="text-lg text-alto-500 mt-3">
                Select the columns to vectorize for similarity search and Retrieval-Augmented Generation.
              </p>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 px-5 my-5 relative">
            <div class="rounded-3xl shadow-lg px-8 py-8 text-center">
              <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                3
              </div>
              <h3 class="text-2xl font-bold">Ask Questions & Chat</h3>
              <p class="text-lg text-alto-500 mt-3">
                Engage with your data through our real-time question answering and chat features.
              </p>
            </div>
          </div>
          <div class="w-full md:w-1/2 lg:w-1/4 px-5 my-5 relative">
            <div class="absolute bg-chateauGreen-500 text-white uppercase text-xs font-bold px-3 py-2 right-0 rotate-12">Optional</div>
            <div class="rounded-3xl shadow-lg px-8 py-8 text-center">
              <div class="bg-chateauGreen-200 rounded-full w-16 h-16 mx-auto mb-5 flex items-center justify-center text-3xl text-chateauGreen">
                4
              </div>
              <h3 class="text-2xl font-bold">Build Your Application</h3>
              <p class="text-lg text-alto-500 mt-3">
                Select tools to interact with your CSV with widgets and APIs for yourself and your customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
    };
  },
  mounted() {
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>
